// The signed recipient list (docs/07 "Signed recipient list") as ocs-proto's
// `recipientListDocument` accepts it and `verifyRecipientList` returns it:
// `ocs_proto::recipients::RecipientList` through serde-wasm-bindgen. Ids are 16-byte
// `Uint8Array`s, keys are their wire encodings, `version` is a number.
import type { IdBytes, SigAlg } from "./frames";

export type DeviceKind = "iphone" | "ipad" | "browser" | "recovery" | "android";

export const DEVICE_KINDS: readonly DeviceKind[] = ["iphone", "ipad", "browser", "recovery", "android"];

export interface VerifyingKey {
  alg: SigAlg;
  bytes: Uint8Array;
}

export interface Recipient {
  device_id: IdBytes;
  kind: DeviceKind;
  /** The HPKE recipient key: uncompressed SEC1 P-256 (65 bytes). */
  encryption_public_key: Uint8Array;
  auth_public_key: VerifyingKey;
}

export interface RecipientList {
  user_id: IdBytes;
  version: number;
  recipients: Recipient[];
}

/** What the account key signed: the API's `RecipientListDto` with bytes decoded. */
export interface SignedRecipientList {
  document: Uint8Array;
  /** Milliseconds since the epoch, covered by the signature. */
  signedAt: number;
  signature: VerifyingKey;
}
